import { render } from "./ChangePasswordView.vue?vue&type=template&id=4bd8f97f&scoped=true&ts=true"
import script from "./ChangePasswordView.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordView.vue?vue&type=script&lang=ts"

import "./ChangePasswordView.vue?vue&type=style&index=0&id=4bd8f97f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd8f97f"]])

export default __exports__